import Link from "next/link";
import {
    FileText,
    Home,
    Briefcase,
    Scale,
    Building2,
} from "lucide-react";

const services = [
    {
        title: "Rental Agreement",
        icon: FileText,
        link: "/rental-agreement",
    },
    {
        title: "Civil Services",
        icon: Building2,
        link: "/civil",
    },
    {
        title: "Lease Agreement",
        icon: Scale,
        link: "/lease-agreement",
    },
    {
        title: "Business Card",
        icon: Briefcase,
        link: "/home-loan",
    },
];

const authenticate = true;

const ServicesSection = () => {
    return (
        <section className="w-full bg-pink-50">
            <div className="max-w-6xl mx-auto px-4">
                <div className="flex overflow-x-auto lg:flex-wrap lg:justify-center gap-6 whitespace-nowrap scrollbar-hide py-2">
                    {services.map((item, index) => {
                        const Icon = item.icon;

                        return (
                            <Link
                                key={index}
                                href={authenticate ? item.link : "/login"}
                                className="flex-shrink-0 w-[140px] h-[100px] transition flex flex-col items-center justify-center text-center group"
                            >
                                <Icon className="w-8 h-8 text-primary mb-3 group-hover:scale-110 transition" />
                                <span className="text-sm font-medium">
                                    {item.title}
                                </span>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default ServicesSection;